import { io } from 'socket.io-client';
import { environment } from '../../../../environments/environment';
import { game } from '../functions/chess';


export const socket = io(environment.socketUrl);
export var gameId: any;
let startGame: boolean = false;

export function sendsocketData(data: any) {
  socket.emit('move', data);
  socket.emit('switchPlayer');
  if (startGame) {
    socket.emit('startTimer', gameId);
    startGame = false;
  }
}

export function joinGame(data: any) {
  if (data) {
    socket.id = data;
    gameId = data;
    socket.emit('start', data);
    startGame = true;
  }
}

export function getPosition(data: any) {
  if (game.turn() == 'b') {
    socket.emit('getposition', data);
  }
}

